import {
  Box,
  Button,
  CircularProgress,
  Container,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../common/components/general/TSAuthProvider";
import { useTSData } from "../../../common/components/general/TSDataContext";
import { MESSAGING_MODE } from "../../../common/constants/generalConstants";
import { MESSAGING_PAGE_ROUTE } from "../../../common/constants/routerConstants";

const MfaVerifyPage = () => {
  const { mfaPending, verifyOtp, sendOtpMail } = useContext(AuthContext);
  const { setMode: setModeApp } = useTSData();
  const navigate = useNavigate();

  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isSendingMail, setIsSendingMail] = useState(false);


  if (!mfaPending) {
    navigate("/");
    return null;
  }

  const canUseMail = mfaPending.enableMailMfa === true;

  const handleVerify = () => {
    if (!code.trim()) {
      setError("Veuillez saisir le code");
      return;
    }
    setError("");
    setInfo("");
    setIsVerifying(true);

    verifyOtp({
      email:    mfaPending.email,
      password: mfaPending.password,
      otp:      code.trim(),
      onSuccess: () => {
        setIsVerifying(false);
        setModeApp(MESSAGING_MODE);
        navigate(MESSAGING_PAGE_ROUTE);
      },
      onFail: (msg) => {
        setIsVerifying(false);
        setError(msg || "Code incorrect");
        setCode("");
      },
    });
  };

  const handleSendMail = () => {
    setError("");
    setInfo("");
    setIsSendingMail(true);

    sendOtpMail({
      email: mfaPending.email,
      password : mfaPending.password,
      onSuccess: () => {
        setIsSendingMail(false);
        setInfo("Un code à 6 chiffres vous a été envoyé par email.");
      },
      onFail: (msg) => {
        setIsSendingMail(false);
        setError(msg || "Échec de l'envoi du code par email");
      },
    });
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 8 }}>
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "20px",
          padding: "40px",
          backgroundColor: "white",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        {/* Icon */}
        <Typography sx={{ fontSize: "48px" }}>📱</Typography>

        {/* Title */}
        <Typography
          variant="h5"
          sx={{ color: "#1B738A", fontWeight: "bold", textAlign: "center" }}
        >
          Vérification en deux étapes
        </Typography>

        {/* Instruction */}
        <Typography variant="body2" sx={{ color: "gray", textAlign: "center" }}>
          Ouvrez votre application d'authentification (Portnet ID) et saisissez
          le code à 6 chiffres.
        </Typography>

        {/* Code input */}
        <TextField
          fullWidth
          label="Code à 6 chiffres"
          value={code}
          onChange={(e) => {
            setCode(e.target.value);
            setError("");
          }}
          onKeyDown={(e) => e.key === "Enter" && handleVerify()}
          error={!!error}
          helperText={error}
          inputProps={{
            maxLength: 6,
            inputMode: "numeric",
            style: {
              letterSpacing: "0.3em",
              fontSize: "20px",
              textAlign: "center",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography sx={{ fontSize: "18px" }}>🔐</Typography>
              </InputAdornment>
            ),
          }}
          autoFocus
        />

        {/* Info message (e.g. mail sent) */}
        {info && (
          <Typography
            variant="caption"
            sx={{ color: "#1B738A", textAlign: "center" }}
          >
            {info}
          </Typography>
        )}

        {/* Verify button */}
        <Button
          fullWidth
          variant="contained"
          onClick={handleVerify}
          disabled={isVerifying}
          sx={{
            backgroundColor: "#1B738A",
            "&:hover": { backgroundColor: "#155f73" },
            "&:disabled": { backgroundColor: "#cccccc" },
            borderRadius: "10px",
            padding: "12px",
          }}
        >
          {isVerifying ? (
            <CircularProgress size={22} sx={{ color: "white" }} />
          ) : (
            "Vérifier"
          )}
        </Button>
        {/* Send by email — only if enabled for this user */}
        
          <Button
            variant="text"
            onClick={handleSendMail}
            disabled={isSendingMail}
            sx={{ color: "#1B738A", textTransform: "none" }}
          >
            {isSendingMail ? (
              <CircularProgress size={18} sx={{ color: "#1B738A" }} />
            ) : (
              "Recevoir le code par email"
            )}
          </Button>
        

        {/* Cancel */}
        <Button
          variant="text"
          onClick={() => navigate("/")}
          sx={{ color: "gray", textTransform: "none" }}
        >
          Annuler et revenir à l'accueil
        </Button>
      </Box>
    </Container>
  );
};

export default MfaVerifyPage;